const accordions = () => {
const accordions = document.querySelectorAll('.accordion__item');
if(accordions.length > 0) {
    accordions.forEach(accordion => {
        const btn = accordion.querySelector('.accordion__btn');
        btn.addEventListener('click', () => {
            setTimeout(() => {
                const header = document.querySelector(".header");
                const headerHeight = header ? header.offsetHeight : 0;
                window.scrollTo({
                  top: accordion.getBoundingClientRect().top + window.scrollY - headerHeight,
                  behavior: "smooth",
                });
              }, 300);
        })
    })
}
}

export default accordions;